import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'REPORTS';

type EventAction =
  | 'DOWNLOAD_PAYOUT_REPORT'
  | 'DOWNLOAD_PAYOUT_REPORT_CSV'
  | 'DOWNLOAD_ANNUAL_REPORT_CSV'
  | 'DOWNLOAD_VENUE_PAYOUT_ZIP';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportPayoutReportDownload = () => {
  report({
    hitType: 'event',
    eventCategory: 'REPORTS',
    eventAction: 'DOWNLOAD_PAYOUT_REPORT',
  });
};

export const reportPayoutReportCsvDownload = () => {
  report({
    hitType: 'event',
    eventCategory: 'REPORTS',
    eventAction: 'DOWNLOAD_PAYOUT_REPORT_CSV',
  });
};

export const reportAnnualReportCsvDownload = () => {
  report({
    hitType: 'event',
    eventCategory: 'REPORTS',
    eventAction: 'DOWNLOAD_ANNUAL_REPORT_CSV',
  });
};

export const reportVenuePayoutZipDownload = () => {
  report({
    hitType: 'event',
    eventCategory: 'REPORTS',
    eventAction: 'DOWNLOAD_VENUE_PAYOUT_ZIP',
  });
};
